import React from "react";
import { Pagination } from "@mui/material";

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  resultsPerPage,
  totalPatients,
}) => {
  // Set both boundaryCount and siblingCount to 0
  const boundaryCount = 0;
  const siblingCount = 0;

  return (
    <div className="pagination-container">
      <div className="pagination-text">
        Results per page: {resultsPerPage}
      </div>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={onPageChange}
        color="primary"
        showFirstButton
        showLastButton
        boundaryCount={boundaryCount}
        siblingCount={siblingCount}
        className="pagination"
      />
      <div className="pagination-text">
        {`${(currentPage - 1) * resultsPerPage + 1}-${
          currentPage * resultsPerPage
        } of ${totalPatients}`}
      </div>
    </div>
  );
};

export default CustomPagination;
